import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Supply = () => {
  const tokenomicsData = [
    { label: 'Private sale', percentage: 0.10, color: '#22C8BF' },
    { label: 'Pre-sale', percentage: 5.00, color: '#22C8BF' },
    { label: 'Public sale', percentage: 25.00, color: '#22C8BF' },
    { label: 'LP Reward', percentage: 23.40, color: '#22C8BF' },
    { label: 'Reserve', percentage: 3.00, color: '#22C8BF' },
    { label: 'Ecosystem', percentage: 10.00, color: '#22C8BF' },
    { label: 'Marketing', percentage: 20.00, color: '#22C8BF' },
    { label: 'Advisors', percentage: 4.00, color: '#22C8BF' },
    { label: 'Founders', percentage: 8.70, color: '#22C8BF' },
    { label: 'Liquidity/MM', percentage: 0.80, color: '#22C8BF' }
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [displayPercentage, setDisplayPercentage] = useState(0);
  const targetPercentage = tokenomicsData[activeIndex].percentage;

  // Smooth percentage animation
  useEffect(() => {
    let start = displayPercentage;
    const end = targetPercentage;
    const duration = 700;
    const startTime = performance.now();

    const animatePercentage = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const current = start + (end - start) * easeOutQuart;
      setDisplayPercentage(current);

      if (progress < 1) {
        requestAnimationFrame(animatePercentage);
      }
    };

    requestAnimationFrame(animatePercentage);
  }, [activeIndex, targetPercentage]);

  return (
    <div className="flex lg:flex-row flex-col items-center container mx-auto px-4 relative justify-between p-8 min-h-screen bg-black" id="Supply">
      {/* Left side - Total Supply */}
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className='lg:w-1/3'
      >
        <p className='text-white text-5xl font-light uppercase mb-4'>Total Supply</p>
        <p className='text-[#22C8BF] text-5xl font-normal mb-6 tracking-wider'>7,500,000,000 $CPH</p>
        <p className='text-white text-xl font-light max-w-[400px] leading-relaxed'>
          $CPH powers the Ciphegis ecosystem, facilitating payments, incentives, governance, and staking.
        </p>
      </motion.div>

      {/* Center - Circle Animation */}
      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="lg:w-1/3 relative mt-20 lg:mt-0 flex justify-center"
      >
        <div className="relative w-[350px] h-[350px]  lg:w-[400px] lg:h-[400px]">
          {/* Percentage Display */}
          <motion.div 
            className="percent-text absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#22C8BF] text-5xl font-medium z-10"
          >
            {displayPercentage.toFixed(1)}%
          </motion.div>
          
          {/* SVG Background */}
          <motion.div 
            className="absolute inset-0 w-full h-full"
            animate={{ rotate: 360 }}
            transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          >
            <img 
              src="static/images/Supply.svg" 
              alt="Supply Circle" 
              className="w-full h-full"
              style={{
                filter: 'drop-shadow(0 0 4px #22C8BF)'
              }}
            />
          </motion.div>
        </div>
      </motion.div>

      {/* Right side - Tokenomics list */}
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="lg:w-1/3 flex flex-col gap-3 mt-20 lg:mt-0"
      >
        <div className="flex flex-col items-end">
          {tokenomicsData.map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ x: -10 }}
              className={`flex items-center cursor-pointer py-2 px-4 rounded-lg transition-all duration-300 group ${
                activeIndex === index 
                  ? 'bg-[#22C8BF]/10 text-[#22C8BF]' 
                  : 'text-white hover:bg-[#22C8BF]/5'
              }`}
              onMouseEnter={() => setActiveIndex(index)}
            >
              <span className="text-lg font-light">{item.label}</span>
              <span className={`text-lg font-light ml-8 ${
                activeIndex === index ? 'text-[#22C8BF]' : 'text-white group-hover:text-[#22C8BF]'
              }`}>
                {item.percentage.toFixed(2)}%
              </span>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Supply;